import React, {ReactElement, useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {cx} from '@emotion/css';
import Button, {ButtonVariant} from '@fo/designSystem/Buttons/Button/Button';
import BaseModal from '@fo/designSystem/BaseModal/BaseModal';
import {fonts} from '@fo/shared/styles/variables';
import Headers, {HeaderType} from '@fo/designSystem/Text/Headers/Headers';
import Paragraph from '@fo/designSystem/Text/Paragraph/Paragraph';
import EmailSentModalBody from '@fo/components/EmailSentModalBody/EmailSentModalBody';
import ForgotPasswordForm from '@fo/components/Identity/ForgotPasswordForm/ForgotPasswordForm';

import styles from './ForgotPasswordModal.styles';

interface Props {
  onModalClose: () => void;
}

function ForgotPasswordModal({onModalClose}: Props): ReactElement {
  const {formatMessage} = useIntl();
  const [isEmailSent, setIsEmailSent] = useState<boolean>(false);
  return (
    <BaseModal onClose={onModalClose}>
      <div className={cx(styles.container)} data-testid="modal.forgotPassword">
        {isEmailSent ? (
          <EmailSentModalBody>
            <Button
              variant={ButtonVariant.LINK_TEXT}
              id="resendForgotPassword"
              testId="button.resendForgotPassword"
              type="button"
              ariaLabel={formatMessage({id: 'identity.resendVerificationEmailButton'})}
              onClick={() => setIsEmailSent(false)}
            >
              <FormattedMessage id="identity.resendVerificationEmailButton" />
            </Button>
          </EmailSentModalBody>
        ) : (
          <>
            <Headers headerType={HeaderType.H3} alignment={fonts.alignment.CENTER}>
              <FormattedMessage id="phoenix.forgotPassword.modal.title" />
            </Headers>
            <Paragraph alignment={fonts.alignment.CENTER} className={cx(styles.copy)}>
              <FormattedMessage id="phoenix.forgotPassword.modal.copy" />
            </Paragraph>
            <ForgotPasswordForm afterSubmit={() => setIsEmailSent(true)} />
          </>
        )}
      </div>
    </BaseModal>
  );
}
export default ForgotPasswordModal;
